module.exports = __webpack_public_path__ + "img/mobile-desktop-preview.5e781bfa.png";